import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { StatusDto } from "@nestcoinco/hyper-api-gateway-api-client";

import { QUERY_KEYS } from "../constants";
import { handleGetMyDuelOpponent } from "../../api-clients/tournamentsClient";

function useDuelOpponentQuery({
  tournamentId,
  enabled,
}: {
  tournamentId: string;
  enabled: boolean;
}): UseQueryResult<StatusDto, Error> {
  const query = useQuery({
    queryKey: [QUERY_KEYS.TOURNAMENT.DUEL_OPPONENT],
    queryFn: () => handleGetMyDuelOpponent(tournamentId),
    enabled: !!tournamentId && enabled,
  });
  return query;
}

export default useDuelOpponentQuery;
